import React from 'react'
import HeroSection from './HeroSection'
import Breadcrumb from './Breadcrumb'

function Partner() {
  return (
    <div className='aboutInfo '>
    <div>
      {/* Reusable Hero Section */}
      <HeroSection
        backgroundImage="/img/rikun3.png"
      />
      <Breadcrumb  />

      <div className='container'> 
        <div className='text-center'>
          <img src='./img/rikun.png' className='rikun-banner'/>
          <a href="https://rikun.co.in/" target="_blank" rel="noopener noreferrer">
    <button className="btn">Visit Website</button>
  </a>
         </div>

         <div className='rikun-text'> 
           <h2 className='rikun-h2'> About Rikun Manufacturing Pvt Ltd</h2>
           <p className='rikun-p'> Welcome to RIKUN Manufacturing Private Limited, where innovation meets precision in metal, plastic, electronic manufacturing, electric vehicle battery, and beyond. As a leading enterprise in the manufacturing industry, we pride ourselves on delivering cutting-edge solutions tailored to meet the diverse needs of our global clientele. With our state-of-the-art facilities, expert team, and unwavering commitment to excellence, we are your trusted partner in realizing your vision.</p>
          </div>

          <div className='text-center'>
          <img src='./img/stats.png' className='rikun-banner2'/>
         </div>
       </div>
      </div>
      </div>
  )
}

export default Partner